// extracted by mini-css-extract-plugin
export default {"noMatch":"style_noMatch__orNpx","content":"style_content__3v0S7","title":"style_title__n-L5c","subTitle":"style_subTitle__NgOLb","text":"style_text__GKq22"};